import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../config";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useLoginModal } from "../contexts/LoginModalContext";
import TermsModal from "./TermsModal";

const LoginLanding = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(true);
  const { setShowLoginModal } = useLoginModal();

  useEffect(() => {
    setIdentifier("");
    setPassword("");
    setErrors({});
  }, [location]);

  const handleLogin = async (event) => {
    event.preventDefault();
    if (!identifier || !password) {
      setErrors({ api: "Please provide all required information." });
      return;
    }
    if (!agreedToTerms) {
      setErrors({ ...errors, terms: "You must agree to the Terms and Conditions." });
      return;
    }
    setLoading(true);
    try {
      const isEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(identifier);
      const response = await fetch(
        `${API_BASE_URL}/login-site`,
        {
          method: "POST",
          body: JSON.stringify({
            email: isEmail ? identifier : null,
            phone: !isEmail ? identifier : null,
            password,
          }),
        }
      );
      const data = await response.json();
      if (response.ok) {
        if (data.statusCode === 1) {
          sessionStorage.setItem("user", JSON.stringify(data));
          if (location.pathname.startsWith("/appointment")) {
            window.location.href = `/appointment`;
          } else {
            window.location.href = `/`;
          }
        } else {
          const apiErrors = data.statusMessage.reduce((acc, error) => {
            if (typeof error === "string") {
              return { ...acc, api: error };
            }
            return { ...acc, api: "An unknown error occurred." };
          }, {});
          setErrors(apiErrors);
        }
      } else {
        const apiErrors = data.statusMessage.reduce((acc, error) => {
          if (typeof error === "string") {
            return { ...acc, api: error };
          }
          return { ...acc, api: "An unknown error occurred." };
        }, {});
        setErrors(apiErrors);
      }
    } catch (error) {
      setErrors({ api: "An unexpected error occurred." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <div className="modal-content p-4 p-5 px-4">
        <div className="modal-header border-0 pb-0">
          <h5 className="modal-title w-100 text-center fw-bold">Log In</h5>
        </div>
        <div className="modal-body  pt-2">
          <form onSubmit={handleLogin} autoComplete="off">
            <div className="mb-3">
              <input
                style={{
                  borderRadius: "14px",
                  padding: "10px",
                  paddingLeft: "20px",
                  border: "1.5px solid #00bcd4",
                }}
                maxLength={64}
                type="text"
                className="form-control form-control-lg"
                placeholder="Email / Phone Number"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                autoComplete="off"
              />
            </div>
            <div className="mb-3 position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control form-control-lg"
                placeholder="Password"
                value={password}
                maxLength={64}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="off"
                style={{
                  borderRadius: "14px",
                  padding: "10px",
                  paddingLeft: "20px",
                  border: "1.5px solid #00bcd4",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  right: "18px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#6c757d",
                  zIndex: 2,
                }}
                onClick={() => setShowPassword((v) => !v)}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </span>
            </div>
            <div className="mb-2 text-start">
              <span
                className="fw-semibold"
                style={{
                  cursor: "pointer",
                  fontSize: "1rem",
                  textDecoration: "underline",
                  color: "#00bcd4",
                }}
                onClick={() => {
                  setShowLoginModal(false);
                  navigate("/forgot-password");
                }}
              >
                Forgot Password?
              </span>
            </div>
            {errors.api && <div className="text-danger mb-2">{errors.api}</div>}
            <div className="mb-2">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="termsCheckbox"
                  checked={agreedToTerms}
                  onChange={e => setAgreedToTerms(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="termsCheckbox">
                  I Agree to the <span style={{color: '#007bff', cursor: 'pointer'}} onClick={() => setShowTerms(true)}>Terms and Conditions</span>
                </label>
              </div>
              {errors.terms && <div className="text-danger">{errors.terms}</div>}
            </div>
            <TermsModal show={showTerms} onClose={() => setShowTerms(false)} />
            <button
              type="submit"
              className="btn btn-info w-100 rounded-pill fw-bold text-white fs-5"
              disabled={loading || !agreedToTerms}
              style={{
                background: "linear-gradient(90deg, #3ed6e0 0%, #1cc7d0 100%)",
                border: "none",
              }}
            >
              {loading ? "Verifying..." : "Log In"}
            </button>
            <div className="text-center mt-3 text-secondary">
              Don't have an account?&nbsp;
              <span
                className=" fw-semibold"
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "#00bcd4",
                }}
                onClick={() => {
                  setShowLoginModal(false);
                  navigate("/signup");
                }}
              >
                Sign Up
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginLanding;
